<template>
  <div>
    <b-modal @show="shown" id="modalEditTelephoneDirections" ref="modalEditTelephoneDirections" :title="$t('Telephone directions detail')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.dir_id > 0">
          <b-form-input type="text" disabled v-model="editItem.dir_id"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Zone')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.dir_id > 0">
          <b-form-input type="text" disabled v-model="zoneName"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="listOfTypeTelDirections" v-model="editItem.dir_coverage_type" :disabled="editItem.dir_id > 0 && editItem.zone_id > 0"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Called prefix')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.called_prefix"/>
          <b-form-checkbox switch v-model="editItem.called_prefix_regexp">{{ $t('Regular Expression') }}</b-form-checkbox>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Calling prefix')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.calling_prefix"/>
          <b-form-checkbox switch v-model="editItem.calling_prefix_regexp">{{ $t('Regular Expression') }}</b-form-checkbox>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Incoming trunk')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.incoming_trunk"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Outgoing trunk')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.outgoing_trunk"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('PBX ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.pbx_id"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Skip')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-checkbox switch size="lg" v-model="editItem.skip"/>
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditTelephoneDirections')" size="md"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      listOfTypeTelDirections: [
        {text: this.$i18n.t('Local coverage'), value: 0},
        {text: this.$i18n.t('Innerzone coverage'), value: 1},
        {text: this.$i18n.t('Intercity coverage'), value: 2},
        {text: this.$i18n.t('International coverage'), value: 3}
      ]
    }
  },
  computed: {
    zoneName () {
      if (this.editItem.zone_id) {
        return JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_ZONE'].name)) + '(' + this.editItem.zone_id + ')'
      } else {
        return this.$t('Empty')
      }
    }
  },
  methods: {
    async shown () {
      if (this.editItem.zone_id) {
        await this.$store.dispatch('Tariffing/GET_TEL_ZONE', this.editItem.zone_id)
      }
    },
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (this.editItem.called_prefix || this.editItem.calling_prefix || this.editItem.incoming_trunk || this.editItem.outgoing_trunk || this.editItem.pbx_id) {
        this.editItem.type = this.editItem.dir_coverage_type
        let response = this.editItem.dir_id !== 0
          ? this.$store.dispatch('Tariffing/UPDATE_TEL_DIRECTIONS', this.editItem)
          : this.$store.dispatch('Tariffing/CREATE_TEL_DIRECTIONS', this.editItem)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            setTimeout(() => this.$emit('update'), 500)
            this.$refs.modalEditTelephoneDirections.hide()
            this.$root.$emit('makeToasts')
          }
        })
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('At least one field mast be non-empty'), 'Error')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/telephony/telephoneDirections/editModal.vue